export const DATE_TIME = 'dd.MM.yyyy HH:mm';
